import styled from "styled-components";

export const ScheduledReportTable = styled.div`
    .p-datatable {
        border-right: none;
        border-left: none;
    }

    i {
        cursor: pointer;
    }
`;
